export default __webpack_public_path__ + "locales/sr-Latn-RS/Notifications.json?hash=70ec0b81d4f4c7e5a67b7ace1b7c2ddd";